import { RootState } from 'store/types';
import { APP_LANGUAGES_ENUM } from 'config/constants';

const selectLanguages = (state: RootState): APP_LANGUAGES_ENUM => state.general.language;

export default selectLanguages;
